import React, {Component} from "react";
import {ff, form} from "@mc/mc-legacy";
import {Button, Card, CardBody, Label} from "reactstrap";
import {FormErrors, reduxForm} from "redux-form";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

type FormData = {
    jmeno: string,
    prijmeni: string,
    datumNarozeni: string,
    email: string,
    oboustranne: boolean,
};

const validate = (data: FormData, props) => {
    const errors: FormErrors<FormData> = {};
    console.log("-> validate", data);
    if (!data.jmeno) {
        errors.jmeno = i18n(props.lang, "Validation_fieldRequired");
    }
    if (!data.prijmeni) {
        errors.prijmeni = i18n(props.lang, "Validation_fieldRequired");
    }
    if (!data.datumNarozeni) {
        errors.datumNarozeni = i18n(props.lang, "Validation_fieldRequired");
    }

    if (!data.email) {
        errors.email = i18n(props.lang, "Validation_fieldRequired");
    }

    return errors;
};

class FoInput extends Component<any> {

    constructor(props) {
        super(props);
    }

    render() {
        const {onClose, handleSubmit, submitting} = this.props;
        return (
            <div>
                <form.Form className={"edit-dialog-form"} onSubmit={handleSubmit}>
                    <form.FormBody>
                        <h2 className={"mt-3 mb-3"}>{i18n(this.props.lang, "ProfilePage_pristupy_AddFO")}</h2>
                        <Card className="mb-3">
                            <CardBody>
                                <div className={"mb-3"}>
                                <Label for={"jmeno"}>{i18n(this.props.lang, "SubjektForm_jmeno")}</Label>
                                <ff.String
                                    autoComplete={"off"}
                                    label={false}
                                    name={"jmeno"}
                                    disabled={submitting}
                                    required />
                                </div>
                                <div className={"mb-3"}>
                                <Label for={"prijmeni"}>{i18n(this.props.lang, "SubjektForm_prijmeni")}</Label>
                                <ff.String
                                    autoComplete={"off"}
                                    label={false}
                                    name={"prijmeni"}
                                    disabled={submitting}
                                    required />
                                </div>
                                <div className={"mb-3"}>
                                    <Label for={"datumNarozeni"}>{i18n(this.props.lang, "SubjektForm_datumNarozeni")}</Label>
                                    <ff.SimpleDate label={false} name={"datumNarozeni"}/>
                                </div>
                                <div className={"mb-3"}>
                                    <Label for={"email"}>{i18n(this.props.lang, "SubjektForm_email")}</Label>
                                    <ff.String
                                        autoComplete={"off"}
                                        label={false}
                                        name={"email"}
                                        disabled={submitting}
                                        required />
                                </div>
                                <div className={"mb-3"}>
                                    <Label for={"oboustranne"} className={"mb-0 d-flex"}>{i18n(this.props.lang, "SubjektForm_pristup_oboustrannyPristup")}</Label>
                                    <ff.Checkbox name='oboustranne' label="" style={{marginTop: -10 }} disabled={submitting} />
                                </div>
                            </CardBody>
                        </Card>
                    </form.FormBody>
                    <form.FormActions disabled={submitting} submitButton={false} cancelButton={false}>
                        <Button className={"pl-3 pr-3"} color="primary" outline onClick={onClose}>{i18n(this.props.lang, "button_cancel")}</Button>
                        <Button
                            className={"ml-2"}
                            color={"primary"}
                            disabled={submitting}
                        >
                            {i18n(this.props.lang, "ProfilePage_pristupyAddPristup")}
                        </Button>
                    </form.FormActions>
                </form.Form>
            </div>
        );
    }
}
const FoInputForm = reduxForm<FormData, any>({
    form: "foInput",
    validate: validate,
})(FoInput);
export default withLang(FoInputForm);
